import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import SITE from '../../Data/siteConfig';
import './ServiceCard.css';

const ServiceCard = ({ image, title, desc, to = '/servislerimiz', badge, featured = false }) => {
  return (
    <article className={`service-card-modern card${featured ? ' service-card-modern--featured' : ''}`}>
      {badge && <span className="scm-badge">{badge}</span>}

      <div className="scm-image-wrap">
        <Link to={to} className="scm-image-link" aria-label={title} tabIndex={-1}>
          <img src={image} alt={`${title} - Bursa teknik servis`} loading="lazy" />
        </Link>
        <div className="scm-overlay" aria-label={`${title} — hızlı iletişim`}>
          <a href={SITE.phoneHref} className="scm-btn scm-call" aria-label={`${title} için ara`}>
            <FaPhoneAlt aria-hidden />
            <span>Ara</span>
          </a>
          <a
            href={SITE.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="scm-btn scm-whatsapp"
            aria-label={`${title} için WhatsApp`}
          >
            <FaWhatsapp aria-hidden />
            <span>WhatsApp</span>
          </a>
        </div>
      </div>

      <div className="scm-body">
        <h3 className="scm-title">
          <Link to={to}>{title}</Link>
        </h3>
        {desc && <p className="scm-desc">{desc}</p>}
      </div>
    </article>
  );
};

export default ServiceCard;
